/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Act_FailInputs */

const vi_cdo_act_fail = /** @type {(inputs: Cdo_Act_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao thất bại`)
};

/**

* @param {Cdo_Act_FailInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_act_fail = /** @type {((inputs?: Cdo_Act_FailInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Act_FailInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_act_fail(inputs)
});